import { getTheme, ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';

const theme: ITheme = getTheme();
const { palette, fonts } = theme;

export const formStyles = mergeStyleSets({
    listItem: {
        listStylePosition: 'inside',
        boxShadow: '0px 6px 13px -7px #000000, 0px 0px 1px 0px rgba(0,0,0,0)',
        border: '1px solid #CCC',
        margin: '10px 5px',
        padding: 10,
        minHeight: 80,
        width: 'calc(100% - 30px)',
    },
    listItemShort: {
        listStylePosition: 'inside',
        // boxShadow: '0px 6px 13px -7px #000000, 0px 0px 1px 0px rgba(0,0,0,0)',
        border: '1px solid #CCC',
        borderTop: '1px solid #888',
        margin: '0px 5px',
        padding: 10,
        minHeight: 40,
    },
    listItemArchived: {
        backgroundColor: palette.neutralLight,
    },
    listItemSelected: {
        backgroundColor: '#C8F7D8',
    },
    containerWithSearchBar: {
        position: 'relative',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 5,
        height: 'calc(100vh - 75px)',
        overflowY: 'auto',
    },
    containerWithSubmenuAndSearchBar: {
        position: 'relative',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 5,
        height: 'calc(100vh - 120px)',
        overflowY: 'auto',
    },
    listTitle: {
        fontSize: fonts.xLarge.fontSize,
        fontWeight: 700,
    },
    listTitleShort: {
        fontWeight: 700,
    },
    clickable: {
        cursor: 'pointer',
    },
    noData: {
        marginTop: 20,
        textAlign: 'center',
    },
    topBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content max-content',
        gridColumnGap: 10,
    },
    oneColumnBlock: {},
    twoColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: 10,
    },
    threeColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    fourColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    fiveColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    sixColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    sevenColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    eigthColumnsBlock: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    firstColumn: {},
    secondColumn: {},
    thirdColumn: {},
    fourthColumn: {},
    error: {
        color: palette.red,
        fontWeight: 700,
        fontSize: 18,
        marginTop: 8,
        textAlign: 'center',
    },
    warn: {
        color: palette.yellow,
        fontWeight: 700,
        fontSize: 18,
        marginTop: 8,
        textAlign: 'center',
    },
    checkbox: {
        marginTop: 2,
    },
    checkboxInsideForm: {
        marginTop: 8,
    },
    checkboxInsideFormAligned: {
        marginTop: 35,
        marginBottom: 6,
    },
    smallButton: {
        height: 20,
    },
    topTitle: {
        fontSize: fonts.xLarge.fontSize,
        fontWeight: 700,
        padding: 10,
        borderBottom: '1px solid #BBB',
        marginBottom: 10,
    },
    topSubTitle: {},
    topBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
    },
    topBarLeft: {},
    topBarRight: {},
    line: {
        marginTop: 5,
    },
    sumLine: {
        marginTop: 5,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 700,
    },
    checkboxWithTopLabel: {
        marginLeft: 6,
        marginTop: 6,
    },
    checkboxWithoutLabel: {
        marginTop: 34,
    },
    grid2: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: 10,
    },
    grid3: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    grid4: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    grid5: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    grid6: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
        gridColumnGap: 10,
    },
    gridAddress: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '150px 80px 80px 1fr 1fr',
        gridColumnGap: 10,
    },
    gridAddressNew: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '80px 1fr 1fr 150px 80px',
        gridColumnGap: 10,
    },
    gridAddressWithoutPostfach: {
        marginTop: 5,
        display: 'grid',
        gridTemplateColumns: '150px 80px 1fr 1fr',
        gridColumnGap: 10,
    },
    gridCell: {
        position: 'relative',
    },
    gridCellRight: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    form: {
        // overflowY: 'auto',
    },
    timestamp: {
        opacity: 0.7,
    },
    timestampLeft: {
        textAlign: 'left',
    },
    timestampRight: {
        textAlign: 'right',
    },
    archivedTest: {
        marginTop: 6,
    },
    archived: {
        opacity: 0.7,
    },
    datePicker: {
        margin: '0 0 15px 0',
        maxWidth: '300px',
    },
    shortValue: {},
    keyValueLine: {
        marginTop: 5,
        verticalAlign: 'top',
    },
    important: {
        backgroundColor: '#ffc3c3',
    },
    bearbeiten: {
        backgroundColor: '#C8F7D8',
    },
    angebotInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    angebotVersendet: {
        backgroundColor: '#F7EBBC',
    },
    angebotAngenommen: {
        backgroundColor: '#C8F7D8',
    },
    serviceInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    serviceVersendet: {
        backgroundColor: '#F7EBBC',
    },
    serviceAngenommen: {
        backgroundColor: '#C8F7D8',
    },
    auftragInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    auftragVersendet: {
        backgroundColor: '#F7EBBC',
    },
    auftragAbgeschlossen: {
        backgroundColor: '#C8F7D8',
    },
    lieferungInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    lieferungVersendet: {
        backgroundColor: '#F7EBBC',
    },
    lieferungAbgeschlossen: {
        backgroundColor: '#C8F7D8',
    },
    rechnungInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    rechnungVersendet: {
        backgroundColor: '#F7EBBC',
    },
    rechnungBezahlt: {
        backgroundColor: '#C8F7D8',
    },
    bestellungInArbeit: {
        backgroundColor: '#F7BDBC',
    },
    bestellungOffen: {
        backgroundColor: '#F7BDBC',
    },
    bestellungVersendet: {
        backgroundColor: '#F7EBBC',
    },
    bestellungTeillieferung: {
        backgroundColor: '#F7EBBC',
    },
    bestellungAbgeschlossen: {
        backgroundColor: '#C8F7D8',
    },
    dataKey: {
        display: 'inline-block',
        width: 40,
    },
    dataKey100: {
        display: 'inline-block',
        verticalAlign: 'top',
        width: 100,
    },
    dataKey120: {
        display: 'inline-block',
        verticalAlign: 'top',
        width: 120,
    },
    dataKeyLine: {
        display: 'block',
    },
    dataValue: {
        display: 'inline-block',
        width: 'calc(100% - 120px)',
    },
    dataValueRight: {
        textAlign: 'right',
    },
    dataValueCenter: {
        textAlign: 'center',
    },
    note: {
        border: '1px solid #CCC',
    },

    // --- positionen table

    positionenTable: {
        marginTop: 5,
        width: '100%',
        border: '1px solid #EEE',
    },
    stickyPositionenHeaderTable: {
        width: 'calc(100% - 50px)',
        color: '#888',
        marginLeft: 17,
        // paddingRight: 34,
        border: 'none',
    },
    positionenHeader: {
        fontWeight: 700,
        paddingRight: 10,
    },
    positionenRow: {},
    positionenCell: {
        verticalAlign: 'top',
        borderTop: '1px solid #EEE',
    },
    positionenNrCell: {
        width: 30,
    },
    positionenArtikelGruppeCell: {
        width: 90,
        wordBreak: 'break-word',
    },
    positionenArtikelNrCell: {
        width: 130,
        wordBreak: 'break-word',
    },
    positionenTextCell: {},
    positionenEinhCell: {
        textAlign: 'left',
        width: 80,
    },
    positionenMengeCell: {
        textAlign: 'right',
        width: 80,
    },
    positionenMoneyCell: {
        textAlign: 'right',
        width: 80,
    },
    positionenMwstCell: {
        textAlign: 'right',
        width: 50,
    },
    positionenLArtCell: {
        textAlign: 'right',
        width: 25,
    },
    positionenActionCell: {
        width: 16,
    },
    positionenAction: {
        cursor: 'pointer',
    },

    transferMengeHeader: {
        textAlign: 'right',
        width: 100,
        marginLeft: 5,
        marginRight: 5,
    },
    transferMenge: {
        textAlign: 'right',
    },
    transferLArt: {
        textAlign: 'right',
        width: 120,
    },

    // --

    reportTable: {
        width: '100%',
        borderSpacing: 0,
    },
    reportFixedHeader: {
        width: 'calc(100% - 115px)',
        position: 'fixed',
        opacity: 0.8,
        backgroundColor: palette.neutralLight,
        borderSpacing: 0,
    },
    reportFixedHeaderNoBgColor: {
        width: 'calc(100% - 115px)',
        position: 'fixed',
        opacity: 0.8,
        borderSpacing: 0,
    },
    reportSummaryTable: {
        fontSize: 16,
        fontWeight: 700,
        marginBottom: 20,
    },
    reportLagerArtikelNrCell: {
        width: 60,
    },
    reportLagerArtikelNrPrintCell: {
        width: 50,
    },
    reportANrCell: {
        width: 85,
    },
    reportANrPrintCell: {
        width: 80,
    },
    reportAuNrCell: {
        width: 85,
    },
    reportAuNrPrintCell: {
        width: 80,
    },
    reportRNrCell: {
        width: 80,
    },
    reportRNrPrintCell: {
        width: 70,
    },
    reportDatumCell: {
        width: 80,
    },
    reportDatumPrintCell: {
        width: 70,
    },
    reportKundeCell: {},
    reportKundePrintCell: {},
    reportAblehnGrundCell: {},
    reportAblehnGrundPrintCell: {},
    reportAuftragStatusCell: {
        width: 80,
    },
    reportAuftragStatusPrintCell: {
        width: 70,
    },
    reportBetreuerKz2Cell: {
        width: 60,
    },
    reportBetreuerKz2PrintCell: {
        width: 50,
    },
    reportKundeLimitedCell: {
        width: 300,
        wordBreak: 'break-all',
    },
    reportKundeLimitedPrintCell: {
        width: 260,
        wordBreak: 'break-all',
    },
    reportLagerCell: {
        width: 60,
        wordBreak: 'break-all',
    },
    reportLagerPrintCell: {
        width: 50,
        wordBreak: 'break-all',
    },
    reportArtikelGruppeCell: {
        width: 150,
        wordBreak: 'break-all',
    },
    reportArtikelGruppePrintCell: {
        width: 130,
        wordBreak: 'break-all',
    },
    reportReclayProduktgruppeCell: {
        wordBreak: 'break-word',
    },
    reportReclayProduktgruppePrintCell: {
        wordBreak: 'break-word',
    },
    reportArtikelNrCell: {
        width: 200,
        wordBreak: 'break-all',
    },
    reportArtikelNrPrintCell: {
        width: 180,
        wordBreak: 'break-all',
    },
    reportArtikelTextCell: {
        wordBreak: 'break-all',
    },
    reportArtikelTextPrintCell: {
        wordBreak: 'break-all',
    },
    reportReclayArtikelTextCell: {
        width: 280,
        wordBreak: 'break-all',
    },
    reportReclayArtikelTextPrintCell: {
        width: 250,
        wordBreak: 'break-all',
    },
    reportEinheitCell: {
        width: 60,
        wordBreak: 'break-all',
    },
    reportEinheitPrintCell: {
        width: 60,
        wordBreak: 'break-all',
    },
    reportMoneyPrintCell: {
        width: 62,
    },
    reportMoneyCell: {
        width: 82,
    },
    reportPercentPrintCell: {
        width: 32,
    },
    reportPercentCell: {
        width: 52,
    },
    reportPercentSmallPrintCell: {
        width: 22,
    },
    reportPercentSmallCell: {
        width: 32,
    },
    reportPosPrintCell: {
        width: 32,
    },
    reportPosCell: {
        width: 52,
    },
    reportCellRight: {
        textAlign: 'right',
    },
    reportTimePrintCell: {
        width: 62,
    },
    reportTimeCell: {
        width: 82,
    },
    reportSummaryPrintCell: {
        // width: 150,
    },
    reportSummaryCell: {
        // width: 160,
    },
    reportSortIcon: {
        fontSize: 10,
        marginLeft: 2,
        marginRight: 2,
    },
    reportFilterInfo: {
        marginBottom: 10,
    },
    growth: {
        fontSize: 12,
        lineHeight: 12,
    },
    positiveGrowth: {
        color: palette.green,
    },
    negativeGrowth: {
        color: palette.red,
    },

    // --

    labelDisabled: {
        color: palette.neutralTertiary,
    },

    // ---

    printButton: {},
    copyButton: {
        color: palette.white,
        background: palette.green,
        borderColor: palette.green,
        selectors: {
            '&:disabled': {
                color: palette.neutralTertiary,
                borderColor: palette.neutralLighter,
                backgroundColor: palette.neutralLighter,
            },
            '&:hover': {
                color: palette.white,
                background: palette.greenDark,
            },
        },
    },
    sendButton: {
        color: palette.white,
        background: palette.magenta,
        borderColor: palette.magenta,
        selectors: {
            '&:disabled': {
                color: palette.neutralTertiary,
                borderColor: palette.neutralLighter,
                backgroundColor: palette.neutralLighter,
            },
            '&:hover': {
                color: palette.white,
                background: palette.magentaDark,
            },
        },
    },
    signButton: {
        color: palette.white,
        background: palette.yellow,
        borderColor: palette.yellow,
        selectors: {
            '&:disabled': {
                color: palette.neutralTertiary,
                borderColor: palette.neutralLighter,
                backgroundColor: palette.neutralLighter,
            },
            '&:hover': {
                color: palette.white,
                background: palette.yellowDark,
            },
        },
    },
    migrateButton: {
        color: palette.white,
        background: palette.red,
        borderColor: palette.red,
        selectors: {
            '&:disabled': {
                color: palette.neutralTertiary,
                borderColor: palette.neutralLighter,
                backgroundColor: palette.neutralLighter,
            },
            '&:hover': {
                color: palette.white,
                background: palette.redDark,
            },
        },
    },
    finalizeButton: {
        color: palette.white,
        background: palette.yellow,
        borderColor: palette.yellow,
        selectors: {
            '&:disabled': {
                color: palette.neutralTertiary,
                borderColor: palette.neutralLighter,
                backgroundColor: palette.neutralLighter,
            },
            '&:hover': {
                color: palette.white,
                background: palette.yellowDark,
            },
        },
    },
    spacerHeight50: {
        height: 50,
    },
    spacerHeight75: {
        height: 75,
    },
    spacerHeight100: {
        height: 100,
    },
    lookupTable: {
        width: '100%',
        borderSpacing: 0,
    },
    lookupTableHead: {
        fontWeight: 700,
    },
    lookupTableBody: {},
    looupTableRow: {
        selectors: {
            '&:hover': {},
            '&:nth-child(odd)': {
                backgroundColor: palette.neutralLight,
            },
            '&:nth-child(even)': {
                backgroundColor: palette.neutralLighterAlt,
            },
        },
    },
    lookupTableCell: {
        padding: '1px 2px',
    },
    lookupTableEditButton: {
        height: 25,
        marginRight: 20,
    },
    lookupTableActionCell: {
        padding: '1px 2px',
        textAlign: 'right',
    },
});
